const INKORA_GHL_WEBHOOK_URL = 'https://services.leadconnectorhq.com/hooks/52yV9zkhaWogJAX2zrl0/webhook-trigger/be152b00-6ee4-4761-b2f9-2a0bd79975e7';

const INKORA_CLOUDINARY_CLOUD_NAME = 'inkoracloud';
const INKORA_CLOUDINARY_UPLOAD_PRESET = 'inkora-contact-uploads';
const INKORA_CLOUDINARY_UPLOAD_URL = 'https://api.cloudinary.com/v1_1/' + INKORA_CLOUDINARY_CLOUD_NAME + '/auto/upload';

const INKORA_MAX_FILE_BYTES = 10 * 1024 * 1024; // 10MB — Cloudinary's free-plan per-file cap

function inkoraGetForm() {
  return document.getElementById('inkora-lead-form');
}

function inkoraPopulateHiddenFields() {
  const form = inkoraGetForm();
  if (!form) return;

  const params = new URLSearchParams(window.location.search);

  const referring = document.getElementById('inkora-referring-page');
  const landing = document.getElementById('inkora-landing-page');
  if (referring) referring.value = document.referrer || '';
  if (landing) landing.value = window.location.href;

  const utmMap = {
    utm_source: 'inkora-utm-source',
    utm_medium: 'inkora-utm-medium',
    utm_campaign: 'inkora-utm-campaign',
    utm_content: 'inkora-utm-content',
    utm_term: 'inkora-utm-term'
  };

  Object.keys(utmMap).forEach((key) => {
    const el = document.getElementById(utmMap[key]);
    if (el) el.value = params.get(key) || '';
  });
}

// Best-effort map from every "coming soon" category label used across the
// menu/home/DTF/stickers pages to one of the interest slugs this form's
// "What are you looking for?" dropdown understands. Anything not listed here
// (or not already a valid slug) falls back to "other".
const INKORA_CATEGORY_TO_INTEREST = {
  'Signs & Displays': 'signs-banners',
  'Awards & Recognition': 'awards-recognition',
  'Custom Manufacturing': 'custom-manufacturing',
  'Outfit Your Team': 'custom-apparel',
  'Get Your Business Noticed': 'signs-banners',
  'Promote Your Brand': 'promotional-products',
  'Recognize & Celebrate': 'awards-recognition',
  'Build Something Custom': '3d-printing',
  'Apparel & DTF': 'custom-apparel',
  'Signs & Stickers': 'signs-banners',
  'Business & Promotional': 'business-marketing',
  'Awards & Custom Manufacturing': 'awards-recognition',
  'For Business': 'business-marketing',
  'Free DTF Sample Pack': 'dtf-transfers',
  'DTF Transfers by Size': 'dtf-transfers',
  'Upload a Print-Ready Gang Sheet': 'dtf-transfers',
  'Holographic Stickers': 'stickers',
  'Glitter Stickers': 'stickers'
};

function inkoraApplyInterest(value, shouldScroll) {
  const select = document.getElementById('inkora-interest');
  if (!select || !value) return;

  const normalized = value.toLowerCase().trim();
  const hasOption = Array.from(select.options).some((opt) => opt.value === normalized);
  select.value = hasOption ? normalized : 'other';

  if (shouldScroll) {
    const section = document.getElementById('inkora-contact-form');
    if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function inkoraSetupInterestFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const interest = params.get('interest');
  if (interest) {
    inkoraApplyInterest(interest, false);
    return;
  }

  // Coming-soon style links use ?category=<Display Name> instead of a slug.
  const category = params.get('category');
  if (!category) return;
  const slug = INKORA_CATEGORY_TO_INTEREST[category] || category.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  inkoraApplyInterest(slug, false);

  const heading = document.querySelector('[data-contact-form-heading]');
  if (heading) {
    const safeCategory = category.replace(/[<>&]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]));
    heading.innerHTML = 'Start Your <span class="inkora-contact-form-card__heading-accent">' + safeCategory + '</span> Project';
  }
}

function inkoraSetupCardListener() {
  document.addEventListener('inkora:set-interest', (event) => {
    const detail = event.detail || {};
    inkoraApplyInterest(detail.interest, true);
  });
}

function inkoraSetupFileDrop() {
  const drop = document.getElementById('inkora-file-drop');
  const input = document.getElementById('inkora-file');
  const text = document.getElementById('inkora-file-drop-text');
  if (!drop || !input) return;

  drop.addEventListener('click', () => input.click());

  input.addEventListener('change', () => {
    if (input.files && input.files[0]) {
      text.textContent = input.files[0].name;
    } else {
      text.textContent = 'Drag and drop files here, or click to upload';
    }
  });

  ['dragover', 'dragenter'].forEach((evt) => {
    drop.addEventListener(evt, (e) => {
      e.preventDefault();
      drop.classList.add('inkora-file-drop--dragover');
    });
  });

  ['dragleave', 'drop'].forEach((evt) => {
    drop.addEventListener(evt, (e) => {
      e.preventDefault();
      drop.classList.remove('inkora-file-drop--dragover');
    });
  });

  drop.addEventListener('drop', (e) => {
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) {
      input.files = e.dataTransfer.files;
      text.textContent = e.dataTransfer.files[0].name;
    }
  });
}

async function inkoraUploadFileToCloudinary(file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', INKORA_CLOUDINARY_UPLOAD_PRESET);

  const response = await fetch(INKORA_CLOUDINARY_UPLOAD_URL, {
    method: 'POST',
    body: formData
  });

  if (!response.ok) throw new Error('Cloudinary upload failed');

  const data = await response.json();
  if (!data.secure_url) throw new Error('Cloudinary response missing secure_url');
  return data.secure_url;
}

function inkoraSetupDatePicker() {
  var dateInput = document.getElementById('inkora-needed-by');
  if (!dateInput || typeof window.flatpickr !== 'function') return;

  window.flatpickr(dateInput, {
    altInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'Y-m-d',
    minDate: 'today',
    disableMobile: false
  });
}

function inkoraShowMessage(text, isError) {
  const el = document.getElementById('inkora-form-message');
  if (!el) return;
  el.textContent = text;
  el.hidden = false;
  el.classList.toggle('inkora-form-message--success', !isError);
  el.classList.toggle('inkora-form-message--error', !!isError);
}

function inkoraSetupSubmit() {
  const form = inkoraGetForm();
  const submitBtn = document.getElementById('inkora-form-submit');
  if (!form || !submitBtn) return;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const fileInput = document.getElementById('inkora-file');
    const file = fileInput && fileInput.files ? fileInput.files[0] : null;

    if (file && file.size > INKORA_MAX_FILE_BYTES) {
      inkoraShowMessage('That file is too large (max 10MB). Please email it to info@helloinkora.com instead, or send your message without it.', true);
      return;
    }

    submitBtn.disabled = true;
    inkoraShowMessage('Sending...', false);

    const consentTimestamp = document.getElementById('inkora-consent-timestamp');
    if (consentTimestamp) consentTimestamp.value = new Date().toISOString();

    const smsUpdates = document.getElementById('inkora-sms-consent-updates');
    const smsPromotions = document.getElementById('inkora-sms-consent-promotions');

    const formData = new FormData(form);
    const payload = {
      full_name: formData.get('full_name'),
      email: formData.get('email'),
      phone: formData.get('phone'),
      product_interest: formData.get('product_interest'),
      estimated_quantity: formData.get('estimated_quantity') || '',
      needed_by: formData.get('needed_by') || '',
      project_description: formData.get('project_description'),
      lead_source: formData.get('lead_source'),
      referring_page: formData.get('referring_page') || '',
      landing_page: formData.get('landing_page') || '',
      consent_timestamp: formData.get('consent_timestamp') || '',
      sms_consent_updates: smsUpdates && smsUpdates.checked ? 'Yes' : 'No',
      sms_consent_promotions: smsPromotions && smsPromotions.checked ? 'Yes' : 'No',
      email_consent_updates: smsUpdates && smsUpdates.checked ? 'Yes' : 'No',
      email_consent_promotions: smsPromotions && smsPromotions.checked ? 'Yes' : 'No',
      utm_source: formData.get('utm_source') || '',
      utm_medium: formData.get('utm_medium') || '',
      utm_campaign: formData.get('utm_campaign') || '',
      utm_content: formData.get('utm_content') || '',
      utm_term: formData.get('utm_term') || ''
    };

    if (file) {
      try {
        inkoraShowMessage('Uploading your file...', false);
        payload.file_name = file.name;
        payload.artwork_file_url = await inkoraUploadFileToCloudinary(file);
      } catch (err) {
        console.error('INKora contact form — Cloudinary upload failed:', err);
        inkoraShowMessage('We could not upload your file. Please try again, or send your message without it.', true);
        submitBtn.disabled = false;
        return;
      }
    }

    try {
      inkoraShowMessage('Sending...', false);

      const response = await fetch(INKORA_GHL_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('GHL webhook request failed with status ' + response.status);

      inkoraShowMessage("Thanks! We've received your message and will be in touch shortly.", false);
      form.reset();
      inkoraPopulateHiddenFields();
      const dropText = document.getElementById('inkora-file-drop-text');
      if (dropText) dropText.textContent = 'Drag and drop files here, or click to upload';
    } catch (err) {
      console.error('INKora contact form — GHL submission failed:', err);
      inkoraShowMessage('Something went wrong sending your message. Please try again or call us directly.', true);
    } finally {
      submitBtn.disabled = false;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  inkoraPopulateHiddenFields();
  inkoraSetupInterestFromUrl();
  inkoraSetupCardListener();
  inkoraSetupFileDrop();
  inkoraSetupDatePicker();
  inkoraSetupSubmit();
});
